export const StickNoteIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_15460_172997)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.375 14H1.5C1.10218 14 0.720644 13.842 0.43934 13.5607C0.158035 13.2794 0 12.8978 0 12.5L0 1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0L12.5 0C12.8978 0 13.2794 0.158035 13.5607 0.43934C13.842 0.720644 14 1.10218 14 1.5V8.375H9C8.83424 8.375 8.67527 8.44085 8.55806 8.55806C8.44085 8.67527 8.375 8.83424 8.375 9V14ZM9.625 13.375L13.375 9.625H9.625V13.375Z" fill="#674759" />
    </g>
    <defs>
      <clipPath id="clip0_15460_172997">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
